'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _util = require('./util');

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Zendesk = function () {
  function Zendesk() {
    _classCallCheck(this, Zendesk);
  }

  _createClass(Zendesk, [{
    key: 'setup',
    value: function setup() {
      var _this = this;

      this._injectClient();

      this._getIFrame().then(function (iframe) {
        _this._injectCustomCSS(iframe);

        _this._setOnChatStartedListener(iframe);
      });
    }
  }, {
    key: 'position',
    value: function position(direction) {
      var zopimDirection = void 0;

      switch (direction) {
        case 'bottom-left':
          zopimDirection = 'bl';
          break;

        case 'bottom-middle':
          zopimDirection = 'bm';
          break;

        case 'bottom-right':
          zopimDirection = 'br';
          break;

        case 'top-left':
          zopimDirection = 'tl';
          break;

        case 'top-middle':
          zopimDirection = 'tm';
          break;

        case 'top-right':
          zopimDirection = 'tr';
          break;
      }

      this._getZopimRef().then(function (zopim) {
        zopim.livechat.button.setPosition(zopimDirection);
        zopim.livechat.window.setPosition(zopimDirection);
      });
    }
  }, {
    key: '_setOnChatStartedListener',
    value: function _setOnChatStartedListener() {
      var _this2 = this;

      this._getZopimRef().then(function (zopim) {
        zopim.livechat.setOnChatStart(function () {
          _this2._injectCustomCSSForChatWidgetWindow();
        });
      });
    }
  }, {
    key: '_injectCustomCSSForChatWidgetWindow',
    value: function _injectCustomCSSForChatWidgetWindow() {
      var chatWidgetWindow = document.querySelector('[data-test-id="ChatWidgetWindow-iframe"]');

      if (chatWidgetWindow) {
        var style = this._createStyle();

        var head = chatWidgetWindow.contentDocument.querySelector('head');
        head.appendChild(style);
        style.sheet.insertRule('.meshim_widget_widgets_Gravatar.profile_avatar {top: 0px !important;  width: 30px !important; height: 30px !important; }', 0);
        style.sheet.insertRule('.avatar_cell { width: 30px !important; }', 0);
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this._getZopimRef().then(function (zopim) {
        zopim.livechat.hideAll();
      });
    }
  }, {
    key: 'show',
    value: function show() {
      this._getZopimRef().then(function (zopim) {
        zopim.livechat.button.hide();
        zopim.livechat.window.hide();
      });
    }
  }, {
    key: 'prefillForm',
    value: function prefillForm(name, email) {
      if (name && email) {
        this._getZopimRef().then(function (zopim) {
          zopim.livechat.setName(name);
          zopim.livechat.setEmail(email);
        });
      }
    }
  }, {
    key: 'setOffsetHorizontal',
    value: function setOffsetHorizontal(n) {
      this._getZopimRef().then(function (zopim) {
        zopim.livechat.button.setOffsetHorizontal(n);
        zopim.livechat.window.setOffsetHorizontal(n);
      });
    }
  }, {
    key: 'setOffsetVertical',
    value: function setOffsetVertical(n) {
      this._getZopimRef().then(function (zopim) {
        zopim.livechat.button.setOffsetVertical(n);
        zopim.livechat.window.setOffsetVertical(n);
      });
    }
  }, {
    key: '_createStyle',
    value: function _createStyle() {
      var style = document.createElement('style');
      style.appendChild(document.createTextNode(''));
      return style;
    }
  }, {
    key: '_injectCustomCSS',
    value: function _injectCustomCSS(iframe) {
      var style = this._createStyle();

      var head = iframe.contentDocument.querySelector('head');
      head.appendChild(style);
      style.sheet.insertRule('.meshim_widget_widgets_Favicon { background-color: #525252 !important; }', 0);
    }
  }, {
    key: '_injectClient',
    value: function _injectClient() {
      // prettier-ignore

      /* eslint-disable */
      window.$zopim || function (d, s) {
        var z = window.$zopim = function (c) {
          z._.push(c);
        },
            $ = z.s = d.createElement(s),
            e = d.getElementsByTagName(s)[0];

        z.set = function (o) {
          z.set._.push(o);
        };

        z._ = [];
        z.set._ = [];
        $.async = !0;
        $.setAttribute('charset', 'utf-8');
        $.src = "//v2.zopim.com/?47ywiT26KBxPfIncbeWxiW4jnHRorv2B";
        z.t = +new Date();
        $.type = 'text/javascript';
        e.parentNode.insertBefore($, e);
      }(document, 'script');
      /* eslint-enable*/
    }
  }, {
    key: '_getZopimRef',
    value: function _getZopimRef() {
      var _this3 = this;

      if (this._zopimRef !== undefined) {
        return Promise.resolve(this._zopimRef);
      }

      var condition = function condition() {
        return window.$zopim != null;
      };

      var callback = function callback(resolve, reject) {
        window.$zopim(function () {
          _this3._zopimRef = window.$zopim;
          resolve(window.$zopim);
        });
      };

      return (0, _util.waitUntil)(condition, callback);
    }
  }, {
    key: '_getIFrame',
    value: function _getIFrame() {
      var condition = function condition() {
        var zopim = document.querySelector('.zopim');
        var iframe = void 0;

        if (zopim != null) {
          iframe = zopim.querySelector('iframe');
        }

        return iframe != null;
      };

      var callback = function callback(resolve, reject) {
        var zopim = document.querySelector('.zopim');
        var iframe = zopim.querySelector('iframe');
        resolve(iframe);
      };

      return (0, _util.waitUntil)(condition, callback);
    }
  }]);

  return Zendesk;
}();

exports.default = Zendesk;